<!-- Copyright 2023, Common Good Learning Tools LLC -->
<template>
	<k-dialog
		v-model="dialog_open"
		max-width="700"
		persistent
		scrollable
		aria-labelledby="cureum-create-account-title"
		initial-focus-selector="input"
		@keydown.esc="$emit('dialog_cancel')"
	>
		<k-card>
			<k-card-title style="background-color:#ddd"><b id="cureum-create-account-title">Create New Account</b></k-card-title>
			<k-card-text class="mt-3" style="font-size:16px;line-height:21px;">
				<div>Signing in with a {{site_config.app_name}} account will let you create your own activities, lesson plans, and other resources. You will also be able to organize premade and newly-created resources into collections, which you can then share with other users.</div>
				<div class="mt-2 pt-2" style="border-top:1px solid #999">Enter your name and email address, then click “CREATE NEW ACCOUNT”. You should then receive an email with a link to activate your new account. Upon clicking the link, you will be automatically signed in to {{site_config.app_name}}, then asked to establish a password.</div>
				<div>
					<div class="d-flex">
						<k-text-field ref="first_name_field" outlined hide-details label="First name" class="mt-4 mr-1" v-model="first_name" placeholder=""></k-text-field>
						<k-text-field outlined hide-details label="Last name" class="mt-4 ml-1" v-model="last_name" placeholder=""></k-text-field>
					</div>
					<div class="d-flex">
						<k-spacer/>
						<div style="flex:0 0 400px"><k-text-field outlined hide-details label="Email" class="mt-4" autocomplete="email" v-model="email" placeholder=""></k-text-field></div>
						<k-spacer/>
					</div>
				</div>
			</k-card-text>
			<k-card-actions class="pa-3" style="background-color:#ddd">
				<k-btn color="secondary" @click="$emit('dialog_cancel')"><k-icon small class="mr-2">fas fa-xmark</k-icon>Cancel</k-btn>
				<k-spacer></k-spacer>
				<k-btn color="primary" @click="create_new_account">Create New Account<k-icon small class="ml-2">fas fa-arrow-right</k-icon></k-btn>
			</k-card-actions>
		</k-card>
	</k-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	props: {
		// req: { type: String, required: true },
		// nreq: { type: String, required: false, default() { return ''} },
	},
	data() { return {
		first_name: '',
		last_name: '',
		email: '',
		dialog_open: true,
	}},
	computed: {
		...mapState(['site_config']),
		...mapGetters([]),
	},
	watch: {
	},
	created() {
	},
	mounted() {
		this.$nextTick(() => {
			this.$refs.first_name_field?.$refs?.textField?.focus?.()
		})
	},
	methods: {
		create_new_account() {
			let payload = {
				first_name: this.first_name,
				last_name: this.last_name,
				user_email: this.email,
				token_duration: 60,
				token_type: 'create_account'
			}
			U.ajax('send_token_signin_email', payload, result=>{
				U.loading_stop()
				let msg
				if (result.status != 'ok') {
					if (result.status == 'account_previously_created') {
						msg = 'An account for this email already exists! Click on Forgot Password to reset password.'
					} else {
						console.log(sr('Error in token create account ajax call: $1', result.status))
						msg = 'The one-time sign-in link could not be sent.'
						//msg = result.status
					}

				} else {
					msg = 'New account verification email sent. <b>Please check your spam or junk folder</b> if you don’t receive the link within one minute, and remember that <b>the link will expire after one hour</b>.'
				}
				this.$alert(msg).then(x=>this.$emit('dialog_cancel'))
			})
		}
	}
}
</script>

<style lang="scss">
</style>
